const MOD11 = 11;

/* eslint-disable import/prefer-default-export */

export const kontrollsifferMod11 = (tall) => {
    let kontrollsiffer = 2;
    let sum = 0;

    for (let i = tall.length - 2; i >= 0; i -= 1) {
        sum += tall.charAt(i) * kontrollsiffer;

        kontrollsiffer += 1;

        if (kontrollsiffer > 7) {
            kontrollsiffer = 2;
        }
    }

    const result = MOD11 - (sum % MOD11);

    return result === MOD11 ? 0 : result;
};

/* eslint-enable import/prefer-default-export */
